/**
 * Convert the given string to a rounded 
 * number of two decimal places.
 * @param {string} number The number to round to two decimal places.
 * @returns {number} The given number rounded to two decimals places or 0.00 if the number isNaN or otherwise could not be formatted.
 */
const fixNumber = (number) => { 
    let result = parseFloat(number)
    if (isNaN(result)) {
        result = 0
    }

    return result.toFixed(2)
}

/**
 * Clean up a numeric input value by removing commas and 
 * symbols and return a float ready to be used in a 
 * calculation.
 * @param {string | null} value The number to round to two decimal places.
 * @returns {number} The given number rounded to two decimals places or 0.00 if the number isNaN or otherwise could not be formatted.
 */
const clean = (value) => {
    if (!value || (value.length <= 0) || (typeof value !== 'string')) {
        return value || 0
    }

    const result = parseFloat(value.replace(/[^0-9\.\-]/g, ''))
    if (!result || isNaN(result)) {
        return 0
    }

    return result
}

module.exports = {
    fixNumber,
    clean
}